import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import {
  avatarOrgLabelStylesSAG,
  avatarOrgLabelStylesSHS,
} from './avatar-org.styles';

@Directive({
  selector: '[sag-ui-avatar-org]',
})
export class AvatarOrgDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>
  ) {}

  ngOnInit(): void {
    const avatarNameLabelStyles = componentStylesByTheme(
      this.theme,
      avatarOrgLabelStylesSAG,
      avatarOrgLabelStylesSHS
    );
    style(this.elementRef, avatarNameLabelStyles());
  }
}
